var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var PostInteraction = /** @class */ (function () {
    function PostInteraction() {
    }
    /*****************************************************************************************************
        * Is using route "api/post/{id}/like" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    PostInteraction.GetLikes = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/like", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/like" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostInteraction.LikePost = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/like", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/dislike" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostInteraction.DislikePost = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/dislike", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/comment" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UserCommentsDownloadDto}
    ******************************************************************************************************/
    PostInteraction.GetPostComments = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/comment", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/comment" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @param {UserCommentDownloadDto} commentToDelete
        * @returns {UserCommentsDownloadDto}
    ******************************************************************************************************/
    PostInteraction.DeletePostComment = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/comment", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.commentToDelete
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/comment" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {UserCommentDownloadDto} commentToPatch
        * @returns {UserCommentsDownloadDto}
    ******************************************************************************************************/
    PostInteraction.UpdatePostComment = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/comment", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.commentToPatch
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/rate" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UserRatingsDownloadDto}
    ******************************************************************************************************/
    PostInteraction.GetPostRatings = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/rate", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/comment" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {UserCommentUploadDto} comment
        * @returns {UserCommentsDownloadDto}
    ******************************************************************************************************/
    PostInteraction.AddPostComment = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/comment", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.comment
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/rate" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {UserCommentUploadDto} comment
        * @returns {UserCommentsDownloadDto}
    ******************************************************************************************************/
    PostInteraction.AddPostRating = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/rate", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.comment
        });
    };
    return PostInteraction;
}());
export { PostInteraction };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PostInteraction.js.map